import checkValidEmail from './check-valid-email';
import getDevices from './get-devices';
import pushToDataLayer from './push-to-data-layer';
import {
  submitSalesforceLead,
  submitSalesforceNewsletter,
  RESIDENCE_COUNTRIES
} from './salesforce-helpers';
import userRoleOptions from './user-role-options';
import crewRoleOptions from './crew-role-options';

export {
  checkValidEmail,
  getDevices,
  pushToDataLayer,
  RESIDENCE_COUNTRIES,
  submitSalesforceLead,
  submitSalesforceNewsletter,
  userRoleOptions,
  crewRoleOptions
};
